<style>
  .v-card.template-gallery__item {
    margin: 0 auto;
    &.new {
      max-width: 200px;
      margin: 0 auto;
      .v-card__title, .v-icon {
        color: #fff;
        font-weight: normal;
      }
    }
  }
  .template--selected {
    background-color: #eaf1ff;
  }
</style>

<template>
  <v-col cols="12" :md="getMdValue" :lg="getLgValue">
    <TemplateGalleryListItem
      v-if="displayMode === 'list'"
      :template="template"
      :timestampFormatted="timestampFormatted(template.timestamp, true)"
      :onTemplateGalleryItemClick="onTemplateGalleryItemClick"
    />

    <TemplateGalleryPredefinedItem
      v-if="templateType === 'predefined'"
      :loading="loading"
      :template="template"
      :getScreenshotSrc="getScreenshotSrc"
    />

    <TemplateGalleryNewItem
      v-if="templateType === 'new'"
      :onTemplateGalleryItemClick="onTemplateGalleryItemClick"
    />

    <TemplateGalleryUserItem
      v-if="templateType === 'user'"
      :loading="loading"
      :template="template"
      :timestampFormatted="`${timestampFormatted(template.timestamp)} ${timestampFormatted(template.timestamp, true)}`"
      :onTemplateGalleryItemClick="onTemplateGalleryItemClick"
    />

    <!-- grid/list gallery layout buttons -->
    <div style="margin-top: 50px; display: flex; justify-content: center;">
      <slot name="content"></slot>
    </div>
  </v-col>
</template>

<script>
import Mixin from '@/mixins/mixin';
import TemplateGalleryPredefinedItem from '@/components/gallery/TemplateGalleryPredefinedItem.vue';
import TemplateGalleryListItem from '@/components/gallery/TemplateGalleryListItem.vue';
import TemplateGalleryNewItem from '@/components/gallery/TemplateGalleryNewItem.vue';
import TemplateGalleryUserItem from '@/components/gallery/TemplateGalleryUserItem.vue';

export default {
  name: 'TemplateGalleryItem.vue',
  components: {
    TemplateGalleryUserItem,
    TemplateGalleryNewItem,
    TemplateGalleryListItem,
    TemplateGalleryPredefinedItem,
  },
  props: ['template', 'templateType', 'displayMode'],
  data: () => ({
    loading: false,
    cycle: false,
  }),
  mixins: [Mixin],
  methods: {
    timestampFormatted(timestamp, wantTime) {
      let result = '';
      let options = '';
      if (wantTime) {
        options = { hour12: false, hour: '2-digit', minute: '2-digit' };
        result = new Date(timestamp).toLocaleTimeString('en-US', options);
      } else {
        options = {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        };
        result = new Date(timestamp).toLocaleDateString('en-US', options);
      }

      return result;
    },
    onTemplateGalleryItemClick() {
      if (!this.template) {
        this.createNewTemplate();
      } else if (this.templateType === 'predefined' || this.templateType === 'userPublished') {
        this.useTemplate();
      } else {
        this.openTemplate();
      }
    },
    getIcon(template) {
      const iconPath = template.icon || 'default-template-icon.jpg';
      // eslint-disable-next-line
      const images = require.context('../../assets/', false, /\.jpg$/)
      // eslint-disable-next-line
      return images('./' + iconPath)
    },
    createNewTemplate() {
      this.$router.push('template/new');
    },
    openTemplate() {
      this.$router.push(`/template/${this.template.uuid}`);
      // eslint-disable-next-line
      // this.$router.push(`templates/user/${this.$store.state.user._id}/template/${this.template.uuid}`);
    },
    isMine(templateId) {
      return templateId && this.$store.state.user.templates.some((template) => template.uuid === templateId);
    },
  },
  computed: {
    getMdValue() {
      return this.templateType === 'predefined' && this.template.screenshots ? 6 : 4;
    },
    getLgValue() {
      let result = 4;
      const isPredefinedItem = this.templateType === 'predefined';
      const isNewItem = this.templateType === 'new';
      if (isPredefinedItem) {
        result = this.template.screenshots ? 6 : 4;
      }
      if (isNewItem) {
        result = 2;
      }
      return result;
    },
  },
};
</script>
